import { render, staticRenderFns } from "./MyKennelRegistrationRequest.vue?vue&type=template&id=5547246c"
import script from "./MyKennelRegistrationRequest.vue?vue&type=script&lang=ts"
export * from "./MyKennelRegistrationRequest.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports